// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideUnlink as RawLucideUnlink } from "lucide-react";
export const LucideUnlink = /* @__PURE__ */ createIcon(RawLucideUnlink, "LucideUnlink", 2);
